import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function LocationUrl() {
  const { t } = useTranslation();
  const location = useLocation();
  let title = '';
  if (location.pathname === '/dashboard') {
    title = t('components.common.LocationUrl.dashboard');
  } else if (location.pathname.includes('/reports/')) {
    title = t('components.common.LocationUrl.informs');
  } else if (location.pathname.includes('/operations/')) {
    title = t('components.common.LocationUrl.cash_management');
  } else if (location.pathname.includes('/customer/')) {
    title = t('components.common.LocationUrl.customer');
  } else if (location.pathname.includes('/terminals/')) {
    title = t('components.common.LocationUrl.sell_points');
  } else if (location.pathname.includes('/employees/')) {
    title = t('components.common.LocationUrl.workers');
  } else if (location.pathname.includes('/rooms')) {
    title = t('components.common.LocationUrl.rooms');
  } else if (location.pathname.includes('/reservations/')) {
    title = t('components.common.LocationUrl.reservation');
  } else if (location.pathname.includes('/inventory/')) {
    title = t('components.common.LocationUrl.inventory');
  } else if (location.pathname.includes('/settings/')) {
    title = t('components.common.LocationUrl.settings');
  }

  return title;
}

export default LocationUrl;
